define('view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyDayItemView',['require','lib/view/LayoutView','lib/Utils','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    var Config = require('Config');

    /**
     * Time flexible item view
     *
     * @class TimeFlexibleWeeklyDayItemView
     */
    return LayoutView.extend({

        template: '#time_flexible_weekly_day_item_view',
        
        triggers: _.extend({
            'click': 'select:time',
        }, Utils.ifParams(!Utils.isIos(), {
            'mouseenter': 'hover:time'
        })),
        
        modelEvents: {
            'change': 'render'
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.time_diff = this.getOption('clientTimeZone').get('time_diff');
            result.is_empty_day = this.getOption('isEmptyDay');
            result.is_day_off = this.getOption('isDayOff');
            result.is_wl_shows = this.getOption('isWlShows'); //show slot once

            result.show_wl = false;

            if (Config.getInstance().getPluginStatus('waiting_list') && !result.is_wl_shows) {
                result.show_wl = result.is_empty_day && !result.is_day_off;
            }
           // console.log(result);

            return result;
        }

    });

});
